type InterpolateAll = (regexp: RegExp, str: string, placeholders?: Partial<Record<string, string>>) => string;
export const interpolateAll: InterpolateAll = (regexp, str, placeholders = {}) => {
  if (!regexp.global) {
    throw new Error('Regular expression must be a global match');
  }

  return str.replace(regexp, (match, key: string) => {
    const value = placeholders[key];

    return value ?? match;
  });
};

type SeparateAll = <T>(items: T[], separator: string) => (string | T)[];
export const separateAll: SeparateAll = <T>(items: T[], separator: string) => {
  const l = items.length;

  return items.reduce<(string | T)[]>((memo, item, i) => {
    memo.push(item);
    if (l > 1 && i < l - 1) {
      memo.push(separator);
    }

    return memo;
  }, []);
};
